import React, { useState } from 'react'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
import { Link } from 'react-router-dom';
import { useVisit } from '../../Hook/App';
import Chart from '../../Components/Chart'
import { addDay, agoDay } from '../../Utils';
function Index() {
    const { item, Share } = useVisit();

    return (
        <Layout>
            <HeaderMain lable={item.name} leftitem={<i onClick={Share} class="fas fa-share-alt"></i>} />
            <div className='item-poster'>
                <Link to={"/item/" + item.id} state={{ item: item }}>
                    <div className='d-flex item-form'>
                        <img src={item.images && item.images[0]} />
                        <div className=' text-item'>
                            <p>{item.name}</p>
                            <span>{item.category && item.category.title}</span>
                            <span>انقضا <span>{item.created_at && addDay(item.created_at, 30, 'fa')}</span></span>
                        </div>
                    </div>
                    <div className='px-2'>
                        <button>مشاهده جزئیات کامل اگهی</button>
                    </div>
                </Link>
            </div>
            {item.meta_data && item.meta_data.vip ?
                <div>
                    <div className='d-flex bg-white justify-content-between my-3 px-3 py-4'>
                        <span>مدت باقی مانده از طرح </span>
                        <span><span>{item.meta_data && agoDay(item.meta_data.vip)}</span> روز دیگر</span>
                    </div>
                </div>
                : null}
            <div className='increase-visit d-flex '>

                <div>
                    <div className='d-flex visit visit-color'>
                        <i class="fas fa-eye"></i>
                        <p><span>{item.chart_data && item.chart_data.reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0) || 0}</span> نفر این اگهی را دیده اند</p>
                    </div>
                </div>
                <Link to={"/VisitIncrease/" + item.id} style={{ borderRadius: "30px" }} className='badge bg-primary py-2 text-white'><i class="fas fa-level-up-alt"></i> ویژه کردن آگهی</Link>
            </div >

            <Chart values={item.chart_data || []} labels={['6 روز پیش', '5 روز پیش', '4 روز پیش', '3 روز پیش', '2 روز پیش ', 'دیروز', 'امروز'].reverse()} />


        </Layout>
    )
}

export default Index
